export enum Steps {
  init,
  thanks,
}
